(() => {
  'use strict';

  // Adds `in-view` once for elements marked with `.reveal`.
  // CSS handles the transition from hidden -> visible state.
  const revealSections = document.querySelectorAll('.reveal');
  if (!revealSections.length) {
    return;
  }

  // Reveal each section once when it enters the viewport.
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        // Mark as visible and stop observing so each element animates only once.
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.16,
      rootMargin: '0px 0px -8% 0px'
    }
  );

  revealSections.forEach((section) => revealObserver.observe(section));
})();
